import React from 'react';

import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function DeleteModal({
  heading,
  firstButtonText,
  pressSecondButton,
  pressFirstButton,
  secondButtonText,
  pressCloseButton,
  body,
  modal,
  dataId,
}) {
  return (
    <div>
      <React.Fragment>
        <BootstrapDialog
          onClose={pressCloseButton}
          aria-labelledby="customized-dialog-title"
          open={modal}
          fullWidth
        >
          <DialogTitle
            sx={{ m: 0, p: 1, backgroundColor: '#20488a', color: 'white' }}
            id="customized-dialog-title"
          >
            {heading}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={() => pressCloseButton()}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'white',
            }}
          >
            X
          </IconButton>
          <DialogContent dividers>{body}</DialogContent>
          {firstButtonText || secondButtonText ? (
            <DialogActions sx={{ backgroundColor: '#e6e9ed' }}>
              <div className="flex justify-around w-full">
                <button
                  className="inline-flex px-6 py-2 text-blue-900 rounded-3xl border border-solid border-blue-900-600 hover:text-white hover:bg-blue-900 focus:bg-blue-900"
                  onClick={() => pressFirstButton()}
                >
                  {firstButtonText}
                </button>
                <button
                  className="inline-flex px-6 py-2 text-white rounded-3xl  bg-blue-900 hover:bg-blue-800 focus:bg-blue-900"
                  style={{
                    backgroundColor:
                      secondButtonText === 'Delete'
                        ? '#DC2626'
                        : secondButtonText === 'Logout'
                        ? '#DC2626'
                        : null,
                  }}
                  onClick={() => pressSecondButton(dataId)}
                >
                  {secondButtonText}
                </button>
              </div>
            </DialogActions>
          ) : null}
        </BootstrapDialog>
      </React.Fragment>
    </div>
  );
}
